import InteractiveLoaderComponent, {
    InteractiveLoaderProps,
} from '@r1-frontend/ui-react/components/loaders/InteractiveLoader';

type TBaseProps = Omit<InteractiveLoaderProps, 'videoSrc'>

type TProps = TBaseProps & {
    videoSrc?: string,
}
const InteractiveLoader = ({
    videoSrc = '/static/images/full-buy/loaders/dog_in_box.mp4',
    textItems,
    delay,
    loopSegmentAtIndex,
    finished,
    className,
}: TProps) =>
    <InteractiveLoaderComponent
        className={className}
        videoSrc={videoSrc}
        textItems={textItems}
        delay={delay}
        loopSegmentAtIndex={loopSegmentAtIndex}
        finished={finished}
    />;

export default InteractiveLoader;
